(function () {
  var STAGGER_MS = 70;

  function escapeChar(c) {
    if (c === '&') return '&amp;';
    if (c === '<') return '&lt;';
    if (c === '>') return '&gt;';
    return c;
  }

  function splitTitle(el) {
    if (el.dataset.vdDone) return;
    el.dataset.vdDone = '1';

    var text = el.textContent;
    el.setAttribute('aria-label', text.trim());

    var html = '';
    var letterIndex = 0;

    for (var i = 0; i < text.length; i++) {
      var c = text[i];
      if (c === ' ') {
        html += '<span class="vd-space" aria-hidden="true"> </span>';
      } else {
        var delay = letterIndex * STAGGER_MS;
        html += '<span class="vd-letter" aria-hidden="true" style="--vd-delay:' + delay + 'ms">' + escapeChar(c) + '</span>';
        letterIndex++;
      }
    }

    el.innerHTML = html;
  }

  function init(root) {
    var els = (root || document).querySelectorAll('[data-velvet-drift]');
    for (var i = 0; i < els.length; i++) {
      splitTitle(els[i]);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(); });
  } else {
    init();
  }

  if (window.Shopify && Shopify.designMode) {
    document.addEventListener('shopify:section:load', function (e) {
      init(e.target);
    });
  }
})();
